import { Box } from "@mui/material";
import React from "react";

export interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export const TabPanel = (props: TabPanelProps) => {
    const { children, value, index } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`settings-tabpanel-${index}`}
            aria-labelledby={`settings-tab-${index}`}
        >
            {value === index && (
                <Box sx={{ p: 3, pb: 0 }}>
                    <span>{children}</span>
                </Box>
            )}
        </div>
    );
}
